<script>
  import { onMount, tick } from 'svelte';
  import SvelteSwitch from '../../lib/components/SvelteSwitch.svelte';
  import { t9n } from '../../lib/translate.js';
  import session from '../../lib/session.js';
  import { TS } from '../../config/translation-keys.js';

  // component options  ------------------------------------------------------ //

  export let input;

  // internal variables ------------------------------------------------------ //

  let switcher;
  let items = [];
  let all_selected = false;

  // translated strings ------------------------------------------------------ //

  let labels = {
    tooltip: null,
    select_all: null,
    btn_back: null,
    btn_next: null,
  };

  // utility functions -------------------------------------------------------- //

  const set_all = value => {
    input.products = input.products.map(p => {
      p.value = value;
      return p;
    });
  };

  const toggle_all = () => {
    set_all(all_selected);
  };

  const check_all = () => {
    return input.products.every(p => p.value === true);
  };

  const set_selection_range = e => {
    if (!e.target.checked) {
      all_selected = false;
    } else {
      all_selected = check_all();
    }
  };

  const translate_texts = () => {
    labels.autosave = t9n(TS.NEW_ORDER_AUTO_SAVE);
    labels.tooltip = t9n(TS.SETTINGS_LABEL_SELECT_TASK_TYPE);
    labels.select_all = t9n(TS.TXT_SELECT_ALL);
    labels.btn_back = t9n(TS.TXT_BACK);
    labels.btn_next = t9n(TS.TABLE_BUTTON_NEXT);
    labels.btn_save = t9n(TS.CHANGE_PASSWORD_SUBMIT_LABEL);
  };

  // reactive functions ------------------------------------------------------ //

  $: if (!!$session) translate_texts();

  // lifecycle --------------------------------------------------------------- //

  const init = () => {
    tick();
    all_selected = check_all(input.products);
  };

  onMount(init);
</script>

<div class="mdc-layout-grid margin-min-24">
  <div class="mdc-layout-grid__inner">
    <div class="mdc-layout-grid__cell--span-7">

      <!-- Switches -->
      <div id="switch-wrap" style="margin-left: 50px">

        <!-- Tool tip -->
        <div
          id="task-interest-header"
          style="margin-bottom: 18px; margin-left: -20px">
          <div class="tooltip-default ">
            <span id="tooltip_def" class="tooltip-text tooltip-top">
              {labels.tooltip}
            </span>
          </div>
        </div>

        <!-- Switch loop -->
        {#if input.products.length > 0}
          {#each input.products as product}
            <div style="margin-bottom: 10px">
              <SvelteSwitch
                label={product.name}
                bind:checked={product.value}
                on:change={set_selection_range} />
            </div>
          {/each}
        {/if}
      </div>

    </div>

    <div class="mdc-layout-grid__cell--span-4">
      <!-- Main switch -->
      <div id="task-interest-switches">
        <div class="role-switcher">
          <SvelteSwitch
            label={labels.select_all}
            on:change={() => toggle_all()}
            bind:checked={all_selected} />
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Prev / Next buttons -->
<div
  style="display: flex; justify-content: flex-end; margin-top: 32px; position:
  relative">
  <!--  <p class="changes-text">{labels.autosave}</p>-->
  <div style="margin-right: 10px;">
    <button
      onclick="prev_tab()"
      class="mdc-button mdc-button--outlined margin-5">
      <span class="mdc-button__ripple" />
      {labels.btn_back}
    </button>
  </div>

  <button
    onclick="next_tab()"
    data-cy="next"
    class="mdc-button mdc-button--unelevated margin-5">
    <span class="mdc-button__ripple" />
    {labels.btn_next}
  </button>
</div>

<style>
  .changes-text {
    margin-top: 10px;
    margin-right: 10px;
    position: absolute;
    left: 62px;
    opacity: 0.5;
    font-size: 14px;
  }
  /*todo: this needs to be added to global / root! */
  .mdc-switch.mdc-switch--checked .mdc-switch__thumb {
    background-color: #034b97;
    background-color: var(--mdc-theme-primary, #034b97);
    border-color: #034b97;
    border-color: var(--mdc-theme-primary, #034b97);
  }

  .mdc-switch.mdc-switch--checked .mdc-switch__track {
    background-color: #034b97;
    background-color: var(--mdc-theme-primary, #034b97);
    border-color: #034b97;
    border-color: var(--mdc-theme-primary, #034b97);
  }

  .bold-label {
    font-weight: bold;
    margin-left: 10px;
  }

  .role-switcher {
    display: inline-block;
  }

  /* Tooltip
    *******************************************************/

  .tooltip-default {
    position: relative;
    font-size: 12px;
    animation: transition_in 0.6s;
  }

  .tooltip-default .tooltip-top {
    z-index: 1;
    bottom: 100%;
    right: 0;
    left: 50%;
  }

  .tooltip-default .tooltip-text {
    background-color: var(--mdc-theme-secondary);
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 8px 8px;
    padding-left: 30px;
    padding-right: 30px;
    font-size: 13px;
    box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.3);
  }

  .tooltip-default .tooltip-text::after {
    content: ' ';
    position: relative;
    top: 30px;
    left: -150px;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #018786 transparent transparent transparent;
  }

  .fade-in {
    animation: transition_in 1.5s;
  }

  /* Desktop Mode
    *******************************************************/
  @media (min-width: 1025px) {
    #task-interest-switches {
      margin-top: 30px;
    }
  }

  /* Tablet Mode
    *******************************************************/
  @media (min-width: 769px) and (max-width: 1024px) {
    #task-interest-switches {
      margin-top: 30px;
      margin-left: 50px;
    }
  }

  /* Mobile Mode
    *******************************************************/
  @media (min-width: 0) and (max-width: 768px) {
    #task-interest-switches {
      margin-top: 0;
      margin-left: 50px;
    }

    .tooltip-default {
      width: max-content;
    }
  }
</style>
